export const METRIC_KEYS = [
  'calls',
  'meaningful_calls',
  'personal_emails',
  'campaign_emails',
  'new_contacts',
  'new_connections',
  'call_outcomes',
  'connections_by_type',
] as const;

export type MetricKey = (typeof METRIC_KEYS)[number];

export const METRIC_DISPLAY: Record<MetricKey, string> = {
  calls: 'Calls',
  meaningful_calls: 'Meaningful Calls',
  personal_emails: 'Personal Emails',
  campaign_emails: 'Campaign Emails',
  new_contacts: 'New Contacts',
  new_connections: 'New Connections',
  call_outcomes: 'Call Outcomes',
  connections_by_type: 'Connections by Type',
};

export type Granularity = 'hour' | 'day' | 'week' | 'month';
export type RangePreset = 'today' | '7d' | '30d' | '90d' | 'qtd' | 'ytd' | 'custom';
